<template>
  <svg
    class="custom-icon"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2536_6780)">
      <rect width="38" height="38" rx="19" fill="rgb(var(--v-theme-text-secondary))" />
      <path
        d="M18.9994 8.76953C14.9635 8.76953 11.6916 12.0411 11.6916 16.0768C11.6916 20.1128 14.9634 23.3847 18.9994 23.3847C23.0355 23.3847 26.3073 20.1129 26.3073 16.0768C26.3073 12.0408 23.0355 8.76953 18.9994 8.76953Z"
        fill="rgb(var(--v-theme-secondary))"
      />
      <path
        d="M16.0762 24.8462C10.4259 24.8462 5.8457 29.4268 5.8457 35.0774V36.5388C5.8457 37.3461 6.49994 38.0003 7.30714 38.0003H30.692C31.4992 38.0003 32.1534 37.3461 32.1534 36.5388V35.0774C32.1534 29.4271 27.5731 24.8462 21.9229 24.8462H16.0762Z"
        fill="rgb(var(--v-theme-secondary))"
      />
    </g>
    <defs>
      <clipPath id="clip0_2536_6780">
        <rect width="38" height="38" rx="19" />
      </clipPath>
    </defs>
  </svg>
</template>
